import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const revokedApiKeysCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'label',
      title: 'api-keys-name',
      width: 25,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'prefix',
      title: 'api-keys-public-key',
      width: 35,
      alignment: ListColumnAlignment.Left,
      sortable: false,
      position: 2,
      priority: 2
    },
    {
      name: 'revoked_at',
      title: 'api-keys-revoke-date',
      width: 25,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 3,
      priority: 3
    }
  ]
})

export default revokedApiKeysCols
